import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import PayIcon from 'features/pay/icons/PayIcon';
import PayOptionsModal from 'features/pay/components/PayOptionsModal';
import { usePayQuickCTAs } from 'features/pay/hooks/usePayQuickCTAs';
import { useRemovePayTabExperience } from 'features/pay/hooks/useRemovePayTabExperience';
const OverviewPayButton = ({ flex }) => {
    const showsPayButton = useRemovePayTabExperience();
    if (!showsPayButton)
        return null;
    return <PayButton flex={flex}/>;
};
const PayButton = ({ flex }) => {
    const handlers = usePayQuickCTAs('feed_overview');
    const colors = useColors();
    const onPress = useCallback(() => {
        PayOptionsModal.show(handlers);
    }, [handlers]);
    return (<Button brandBorder cards flex={flex} title="Pay" onPress={onPress} leftIcon={<PayIcon width={16} height={16} color={colors.text.textOnBrand}/>} containerStyle={styles.container} leftIconContainerStyle={styles.iconLeft}/>);
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: rem(10),
    },
    iconLeft: {
        paddingRight: rem(6),
    },
});
export default OverviewPayButton;
